import { getIsPageBrokerVisible } from './getIsPageBrokerVisible';
import { IAppState } from '../../common/state';

export const getIsBrokerBannerVisible = (state: IAppState) => {
  const isPageBrokerVisible = getIsPageBrokerVisible(state);
  const isNewbuildingSnippetAvailable = state.newbuildingInformation !== null;

  return isPageBrokerVisible && !isNewbuildingSnippetAvailable;
};
